import Progress from './Progress'

export default function OverallProgress() {
    return (
        <div className='progress-overlay'>
            <Progress/>
        </div>
    )
}
